import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { HeaderService } from "../header/header.service";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Publish } from "src/app/models/shipyard.model";
import { Subject, takeUntil } from "rxjs";
import { MapSkuToProductComponent } from "../dialogs/map-sku-to-product/map-sku-to-product.component";
import { PlanyardService } from "src/app/modules/planyard/planyard.service";
import { SkuGenerateDialogComponent } from "../sku-generate-dialog/sku-generate-dialog.component";

@Component({
  selector: "app-publish-listing",
  templateUrl: "./publish-listing.component.html",
  styleUrls: ["./publish-listing.component.scss"],
})
export class PublishListingComponent implements OnInit, OnDestroy {
  account: string;
  publisListing: any;
  loader: boolean = false;
  asin: string;
  IsCreate : boolean = false;
  selectedhazamatousProduct:any[] = [];
  isShowProduct:boolean = false;
  isSelectedFba :boolean = true;
  publishForm: FormGroup = new FormGroup({
    sellerSku: new FormControl("", [Validators.required]),
    price: new FormControl(0, [Validators.required]),
    qty: new FormControl(1, [Validators.required]),
    handlingTime:new FormControl(),
    itemCondition: new FormControl("new_new", [Validators.required]),
    fullfillmentChannel: new FormControl(true, [Validators.required]),
    hazamatousProduct: new FormControl(null, [Validators.required]),
    hazmat: new FormControl(),
    hazmatUrl:new FormControl(),
    merchantShippingGroup: new FormControl()
  });
  asinLink;
  spin: boolean = false;
  itemConditionArray = [
    { name: "New", value: "new_new" },
    {name: "Used - Good", value:"used_good"},
    { name: "Used - Like New", value: "used_like_new" },
    { name: "Used - Very Good", value: "used_very_good" },
    { name: "Used - Acceptable", value: "used_acceptable" },
  ];
  merchantShippingArray = [];
  hazamtousProduct = [
    { name: "GHS", value: "ghs" },
    { name: "Transportation", value: "transportation" },
    {name: "Not Applicable", value:"not_applicable"},
    { name: "Other", value: "other" },
    { name: "Storage", value: "storage" },
    { name: "Unknown", value: "unknown" },
    { name: "Waste", value: "waste" },
  ];
  ghsProduct = [
    { name: "Amazon Specific No Label With Warning", value: "amzn_specific_no_label_with_warning" },
    {name: "Compressed Gas", value:"compressed_gas"},
    { name: "Corrosive", value: "corrosive" },
    { name: "Environmentally Damaging", value: "environmentally_damaging" },
    { name: "Transportation", value: "transportation" },
    { name: "Explosive", value: "explosive" },
    { name: "Flammable", value: "flammable" },
    { name: "Health Hazard", value: "health_hazard" },
    { name: "Irritant", value: "irritant" },
    { name: "Oxidizing", value: "oxidizing" },
    { name: "Toxic", value: "toxic" },
  ]
  transportProduct = [
    { name: "UN Regulatory Id", value: "united_nations_regulatory_id" },
  ]
  private destroy$ = new Subject<void>();
  accountSkuId: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<PublishListingComponent>,
    private shipyardService: ShipyardService,
    private headerService: HeaderService,
    private snackBar: MatSnackBar,
    private planyardService: PlanyardService,
    private dialog: MatDialog,
  ) {
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.account = e[0];
      this.getMerchantShippingGroup();
    });
  }

  ngOnInit(): void {
    this.publishForm.disable();
    this.publishForm.get("fullfillmentChannel").valueChanges.subscribe((res)=>{
      if(res){
        this.publishForm.controls['qty'].disable();
        this.isSelectedFba = true;
      }else{
        this.publishForm.controls['qty'].enable();
        this.isSelectedFba = false;
      } 
    })
    this.publishForm.get('hazamatousProduct').valueChanges.subscribe((res)=>{
      this.selectHazamatousProduct(res);
    })
  }

  dialogAction(event) {
    if (event === "Create") {
      this.create();
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close();
  }

  search(event) {
    this.asin = event.target.value;
  }

  create() {
    this.spin = true;
    const publishAttributes = {
      ...this.publishForm.value,
      ...this.publisListing,
      totalQuantity: this.publishForm.value.qty,
      condition: this.publishForm.value.itemCondition,
      isFba: this.publishForm.value.fullfillmentChannel,
      title: this.publisListing.itemName,
      supplier_declared_dg_hz_regulation:this.publishForm.value.hazamatousProduct,
      hazmat: this.publishForm.value.hazmatUrl,
      hazmatAspect: this.publishForm.value.hazmat,
      ghsClass: this.publishForm.value.hazmat,
      safety_Data_Sheet_Url: this.publishForm.value.hazmatUrl,
      handlingTime : this.publishForm.value.handlingTime,
      merchantShippingGroup : this.publishForm.value.merchantShippingGroup
    };
    if(this.isSelectedFba){
      publishAttributes.handlingTime = null,
      publishAttributes.merchantShippingGroup = null
    }
    const payload: Publish = {
      account: this.account,
      asin: this.asin,
      attributes: publishAttributes,
    };
    this.shipyardService.CreateFBAInventory(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        this.spin = false;
        if(res){
          this.IsCreate = true
          this.setToaster(res);
        }else{
          this.dialogRef.close();
        }
      },
     error: (err) => {
      this.IsCreate = false;
        this.spin = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: err?.error?.error[0],
            action: "Dismiss",
            type: "error",
          },
        });
       }
   });
  }
  addSkuPopup() { 
     const sku = {
      Sku: this.publishForm.value.sellerSku,
      price: this.publishForm.value.price,
      AccountSkuId: this.accountSkuId
    }
    this.dialog
      .open(MapSkuToProductComponent, {
        width: "700px",
        panelClass: "dialog-container-custom",
        data: {
          sku: sku,
          callBackFn: (dialogRef, e, actions) => {
            this.planyardService.SetSkuMapping(e).pipe(takeUntil(this.destroy$)).subscribe({
            next: (res) => {
              if (dialogRef) {
                dialogRef.close();
              }
              if (actions) {
                actions[1].spin = false;
              }
            },
           error: (err) => {
              if (actions) {
                actions[1].spin = false;
              }
              this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 4000,
                  horizontalPosition: 'center',
                  data: {
                    title: err.error?.error[0],
                    action: 'Dismiss',
                    type: 'error',
                  },
                }
              );
             }
           });
          }
        },
      })
  }
  submit() {
    this.loader = true;
    const payload = {
      asin: this.asin?.toUpperCase(),
      account: this.account,
    };
    this.shipyardService.downloadCatalogAsin(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        this.publisListing = res;
        this.loader = false;
        this.publishForm.enable();
        this.asinLink= "https://www.amazon.com//dp/" + this.publisListing.asin;
        this.publishForm.get('hazamatousProduct').setValue(this.publisListing.supplier_declared_dg_hz_regulation);
      },
     error: (err) => {
        this.loader = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 300000,
          horizontalPosition: "center",
          data: {
            title: err?.error?.error[0],
            action: "Dismiss",
            type: "error",
          },
        });
       }
   });
  }

  setToaster(res?) {
    if (res.length) {
      this.snackBar.openFromComponent(SnackbarComponent, {
        duration: 3000,
        horizontalPosition: "center",
        data: {
          title: res[0]?.message,
          action: "Dismiss",
          type: "error",
        },
      });
    }else if(res?.issues){
      this.snackBar.openFromComponent(SnackbarComponent, {
        duration: 3000,
        horizontalPosition: "center",
        data: {
          title: res.issues[0]?.message,
          action: "Dismiss",
          type: "error",
        },
      });
    } else {
     this.snackBar.openFromComponent(SnackbarComponent, {
        duration: 3000,
        horizontalPosition: "center",
        data: {
          title: "SKU Created Successfully",
          action: "Dismiss",
          type: "success",
        },
      });


      if (res.accountSkuId) {
        this.accountSkuId = res.accountSkuId;
        this.addSkuPopup();
      }
      else{
        this.dialogRef.close();
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  openDialog(){
    this.dialog
    .open(SkuGenerateDialogComponent, {
      width: "400px",
    }).afterClosed().subscribe((sku)=>{
       if(sku){
         this.shipyardService.checkSkuExist(sku).pipe(takeUntil(this.destroy$)).subscribe({
          next: (res) => {
           if(!res){
            this.publishForm.get('sellerSku').setValue(sku);
           }    
         },
         error: (err) => {
          this.snackBar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: "center",
            data: {
              title: err?.error?.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
         }
       });
       }
    })
  }

  selectHazamatousProduct(res){
    this.selectedhazamatousProduct = [];
      if(res == 'ghs'){
        this.isShowProduct = true;
        this.selectedhazamatousProduct = this.ghsProduct;
        this.publishForm.get('hazmat').setValue(this.selectedhazamatousProduct);
        this.publishForm.get('hazmat').setValidators(Validators.required);
        this.publishForm.get('hazmatUrl').setValidators(Validators.required);
      }else if(res == 'transportation'){
        this.isShowProduct = true;
        this.selectedhazamatousProduct = this.transportProduct;
        this.publishForm.get('hazmat').setValue(this.selectedhazamatousProduct);
        this.publishForm.get('hazmat').setValidators(Validators.required);
        this.publishForm.get('hazmatUrl').setValidators(Validators.required);
      }else{
        this.isShowProduct = false;
        this.publishForm.get('hazmat').clearValidators();
        this.publishForm.get('hazmatUrl').clearValidators();
      }
      this.publishForm.get('hazmat').updateValueAndValidity();
  }

  getMerchantShippingGroup(){
    this.shipyardService.GetMerchantShippingGroup(this.account).subscribe({
      next:(res:any)=>{
        this.merchantShippingArray = res;
      },
      error:(err)=>{
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 4000,
          horizontalPosition: "center",
          data: {
            title: err.error?.error[0],
            action: "Dismiss",
            type: "error",
          },
        });
      }
    })
  }
}
